import pipe from './pipe';
import prop from './prop';

export default jwt => pipe(jwt.split('.'), prop(1), atob, JSON.parse);
